// remove this component after login redesign
import { ButtonProps as MuiButtonProps, Theme } from '@mui/material';
import { SystemStyleObject, SxProps } from '@mui/system';
import { FC } from 'react';
import { Button } from '..';
import { ArrowDownIcon } from '../../../../../icons';

export type ButtonProps = {
  text: string;
  color: MuiButtonProps['color'];
  minWidth?: string;
  sx?: Exclude<MuiButtonProps['sx'], Array<unknown>>;
  small?: boolean;
  multiSelect?: boolean;
} & Omit<MuiButtonProps, 'sx'>;

export const ContainedButton: FC<ButtonProps> = ({ text, small, multiSelect, ...buttonProps }) => {
  return (
    <Button
      {...buttonProps}
      small={small}
      variant="contained"
      disableElevation
      endIcon={multiSelect ? <ArrowDownIcon /> : buttonProps.endIcon}
      sx={(theme) => ({
        fontWeight: 500,
        borderRadius: '8px',
        justifyContent: multiSelect ? 'space-between' : 'center',
        paddingY: multiSelect ? '0' : '0.375rem',
        gap: multiSelect ? '0.5rem' : '0',
        '&:hover': {
          '& .MuiButton-endIcon': {
            borderLeftColor: multiSelect ? `#555` : 'none'
          }
        },
        '& .MuiButton-endIcon': {
          marginLeft: multiSelect ? '0' : '0.5rem',
          paddingLeft: multiSelect ? '0.5rem' : '0',
          borderLeftWidth: multiSelect ? '1px' : 'none',
          borderLeftStyle: multiSelect ? 'solid' : 'none',
          borderLeftColor: multiSelect ? `#888` : 'none',
          alignSelf: multiSelect ? 'stretch' : 'center',
          alignItems: 'center',
          mixBlendMode: 'luminosity',
          transition: 'border-left-color .25s'
        },
        '& .MuiButton-startIcon': {
          marginRight: multiSelect ? 'unset' : '0.5rem'
        },
        '&.Mui-disabled': {
          backgroundColor: `${buttonProps.color}.light`,
          color: `${buttonProps.color}.contrastText`,
          '& .MuiButton-endIcon': {
            borderLeftColor: multiSelect ? `#bbb` : 'none'
          }
        },
        ...getParentSx(buttonProps.sx as SxProps<Theme>, theme)
      })}
    >
      {text}
    </Button>
  );
};

export const getParentSx = <Theme extends object>(
  parentSx: SxProps<Theme> | undefined,
  theme: Theme
): SystemStyleObject<Theme> | undefined => {
  if (typeof parentSx === 'function') {
    return parentSx(theme) as SystemStyleObject<Theme>;
  }
  return parentSx as SystemStyleObject<Theme>;
};
